import React, { useState, useEffect } from 'react';
import axios from 'axios';

interface User {
  id: number;
  nombre: string;
  apellido: string;
  segundoApellido: string;
  tipoDocumento: string;
  numeroDocumento: string;
  fechaNacimiento: string;
  paisNacimiento: string;
  departamento: string;
  ciudad: string;
  direccion: string;
  genero: string;
  estadoCivil: string;
  correoElectronico: string;
  telefono: string;
  foto: string;
  documento: string;  // Nuevo campo
  cargo: string;      // Nuevo campo
}

const Perfiles: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  // Fetch users on component mount
  useEffect(() => {
    axios.get('http://localhost:3004/api/usuarios')
      .then(response => {
        setUsers(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching users:', error);
        setLoading(false);
      });
  }, []);

  // Delete user
  const handleDelete = (id: number) => {
    axios.delete(`http://localhost:3004/api/usuarios/${id}`)
      .then(() => {
        setUsers(users.filter(user => user.id !== id));
        alert('User deleted successfully');
      })
      .catch(error => console.error('Error deleting user:', error));
  };

  // Open and Close Modal
  const openModal = (user: User) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedUser(null);
    setIsModalOpen(false);
  };

  // Handle Input Change
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (selectedUser) {
      setSelectedUser({ ...selectedUser, [e.target.name]: e.target.value });
    }
  };

  // Submit Updated User
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (selectedUser) {
      axios.put(`http://localhost:3004/api/usuarios/${selectedUser.id}`, selectedUser)
        .then(response => {
          setUsers(users.map(user =>
            user.id === selectedUser.id ? response.data : user
          ));
          alert('User actualizado');
          closeModal();
        })
        .catch(error => {
          console.error('Error updating user:', error.response?.data || error.message);
          alert('Failed to update user');
        });
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <h1 className="text-2xl font-bold mb-4">User List</h1>
      <table className="min-w-full bg-white border border-gray-300">
        <thead>
          <tr>
            <th className="py-2 px-4 border-b">ID</th>
            <th className="py-2 px-4 border-b">Nombre</th>
            <th className="py-2 px-4 border-b">Apellido</th>
            <th className="py-2 px-4 border-b">Segundo Apellido</th>
            <th className="py-2 px-4 border-b">Documento</th>
          
            <th className="py-2 px-4 border-b">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td className="py-2 px-4 border-b">{user.id}</td>
              <td className="py-2 px-4 border-b">{user.nombre}</td>
              <td className="py-2 px-4 border-b">{user.apellido}</td>
              <td className="py-2 px-4 border-b">{user.segundoApellido}</td>
              <td className="py-2 px-4 border-b">{user.numeroDocumento}</td>
              <td className="py-2 px-4 border-b flex space-x-2">
                <button
                  onClick={() => openModal(user)}
                  className="bg-blue-500 text-white px-2 py-1 rounded"
                >
                  Update
                </button>
                <button
                  onClick={() => handleDelete(user.id)}
                  className="bg-red-500 text-white px-2 py-1 rounded"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {isModalOpen && selectedUser && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-lg">
            <h2 className="text-xl font-bold mb-4">Actualizar Usuario</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-gray-700">Nombre</label>
                <input
                  type="text"
                  name="nombre"
                  value={selectedUser.nombre}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Apellido</label>
                <input
                  type="text"
                  name="apellido"
                  value={selectedUser.apellido}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Segundo Apellido</label>
                <input
                  type="text"
                  name="segundoApellido"
                  value={selectedUser.segundoApellido}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>

              {/* Campos Documento y Cargo, después del Segundo Apellido */}
              <div className="mb-4">
                <label className="block text-gray-700">Documento</label>
                <input
                  type="text"
                  name="documento"
                  value={selectedUser.documento}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">Cargo</label>
                <input
                  type="text"
                  name="cargo"
                  value={selectedUser.cargo}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>

              <div className="flex justify-end space-x-4">
                <button
                  type="button"
                  onClick={closeModal}
                  className="bg-gray-500 text-white px-4 py-2 rounded"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="bg-green-500 text-white px-4 py-2 rounded"
                >
                  Guardar Cambios
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Perfiles;

